#import "../fragments/game.gql"
#import "../fragments/competitions.gql"

query getCompetition($id: Int, $isGuest: Boolean! = true) {
  newCompetition(id: $id) {
    competitors {
      id
      score
      user {
        username
        fullname
      }
    }
    rules
    competitorsWinners {
      id
      sum
      place
      customCurrency
      user {
        username
        fullname
      }
    }
    countPlaces
    dateEnd
    dateStart
    description
    ended
    games {
      ...gameFragment
    }
    id

    # eslint-disable-next-line @graphql-eslint/no-deprecated
    imgActive
    compressedImage {
      webp {
        xs
        sm
        md
        lg
        xl
      }
    }
    inGame
    seoData {
      metaDescription
      metaTitle
      seoText
      h1
      ogTitle
      ogDescription
    }
    name
    nomination
    prizePlaces {
      amount
      start
      end
      customCurrency
    }
    prizeCount
    customCurrency
    shortDescription
    sum
    currency {
      code
    }
    requiredDoge
    objectId
    updateType
    usersCount @skip(if: $isGuest)
    userPlace @skip(if: $isGuest)
    userResults @skip(if: $isGuest)
    ...competitionsFragment
    propsContent {
      props
    }
  }
}
